interface TermsProps {
  onBack?: () => void;
  onNavigate?: (page: string) => void;
}

export function Terms({ onBack, onNavigate }: TermsProps) {
  return (
    <div
      dir="rtl"
      className="px-5 pt-5 pb-12 flex flex-col gap-6"
      style={{ color: "var(--parchment-soft)" }}
    >
      <div>
        {onBack && (
          <button
            onClick={onBack}
            className="mb-4 flex items-center gap-1.5 text-sm"
            style={{ color: "var(--gold-300)", opacity: 0.85 }}
          >
            <span className="text-lg leading-none">→</span> חזרה
          </button>
        )}
        <p
          style={{
            fontFamily: "'Heebo', sans-serif",
            fontSize: 11,
            letterSpacing: "0.25em",
            textTransform: "uppercase",
            color: "var(--gold-400)",
            opacity: 0.9,
          }}
        >
          משפטי
        </p>
        <h1
          className="font-serif"
          style={{
            fontSize: 22,
            fontWeight: 700,
            color: "var(--parchment-soft)",
            marginTop: 4,
          }}
        >
          תנאי שימוש
        </h1>
      </div>

      <LegalSection title="הסכמה לתנאים">
        <p>
          השימוש באתר מהווה הסכמה מלאה לכל תנאי התקנון, לרבות{" "}
          {onNavigate ? (
            <button
              type="button"
              onClick={() => onNavigate("privacy")}
              style={{
                color: "var(--gold-300)",
                textDecoration: "underline",
                background: "transparent",
                border: 0,
                padding: 0,
                cursor: "pointer",
                font: "inherit",
              }}
            >
              מדיניות הפרטיות
            </button>
          ) : (
            "מדיניות הפרטיות"
          )}{" "}
          המופיעה באתר. האתר נועד להצגת תכנים, פרסומות ושירותי המפעיל
          בלבד, והמשתמש מצהיר כי הוא מעל גיל 13 או שיש לו אישור מהוריו או
          אפוטרופוס לשימוש באתר.
        </p>
      </LegalSection>

      <LegalSection title="אחריות ושימוש בתכנים">
        <p>
          האתר והתכנים שבו ניתנים למשתמשים במצבם הנוכחי וללא התחייבות מכל
          סוג שהוא. המידע באתר אינו מהווה ייעוץ מקצועי או המלצה, והמשתמש
          נושא באחריות מלאה לשימוש בתכנים ובהסתמכות עליהם. המפעיל אינו
          אחראי לנזקים ישירים או עקיפים, לרבות נזקים כספיים או תוצאתיים,
          שעלולים להיגרם למשתמש או לצד שלישי עקב השימוש באתר, הסתמכות על
          תכניו או הפסקת פעילות האתר.
        </p>
      </LegalSection>

      <LegalSection title="קניין רוחני">
        <p>
          כל זכויות הקניין הרוחני באתר שייכות למפעיל בלבד, ורבות מהן מוגנות
          בזכויות יוצרים, סימני מסחר ועיצובים. אין להעתיק, להפיץ, לשווק,
          לפרסם או להשתמש בתכנים כלשהם ללא קבלת אישור מראש ובכתב מהמפעיל.
        </p>
      </LegalSection>

      <LegalSection title="שיפוי">
        <p>
          המשתמש מתחייב לשפות את המפעיל על כל נזק, הפסד או חבות הנגרמים
          עקב הפרת תנאי התקנון או שימוש בלתי חוקי באתר.
        </p>
      </LegalSection>

      <LegalSection title="דין וסמכות שיפוט">
        <p>
          תקנון זה כפוף לדין הישראלי וסמכות השיפוט הבלעדית בנושאים הנוגעים
          לו נתונה לבתי הדין הפועלים על פי ההלכה היהודית בלבד.
        </p>
      </LegalSection>
    </div>
  );
}

function LegalSection({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex flex-col gap-2">
      <h2
        className="font-serif pb-2"
        style={{
          fontSize: 16,
          fontWeight: 700,
          color: "var(--gold-300)",
          borderBottom: "1px solid rgba(212,162,74,0.22)",
        }}
      >
        {title}
      </h2>
      <div
        className="leading-relaxed"
        style={{
          fontFamily: "'Heebo', sans-serif",
          fontSize: 13,
          color: "var(--text-secondary)",
          lineHeight: 1.7,
        }}
      >
        {children}
      </div>
    </div>
  );
}
